import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./CustomSelectBox.module.css";
import {  HelperError,Label } from "./ShortTextInput";


function CustomSelectBox({
  label,
  error,
  id,
  onChange,
  value,
  options,
  fullWidth,
  labelColor,
  className,
  style,
  disabled,
  helperText,
  isMulti, // Add this prop to control multi-select
  required,
  placeholder,
  marginBottom = "16px",

}) {
  return (
    <div
      style={{
        marginBottom: marginBottom,
        width: fullWidth ? "100%" : "auto",
      }}
    >
      {/* Label */}
      {label && <Label id={id} label={label} labelColor={labelColor} required={required}/>}

      {/* Select Box */}
      <select
        id={id}
        value={value}
        onChange={onChange}
        className={classNames(styles.selectBase, {
          [styles.selectError]: error,
          [styles.selectDisabled]: disabled,
        }, className)}
        style={style}
        disabled={disabled}
        aria-describedby={`${id}-helper-text`}
        multiple={isMulti} // Enable multi-select if the prop is passed
      >
        {!isMulti && (
        <option value="" disabled>
          {placeholder}
        </option>
        )}
        {options.map((option, index) => (
          <option key={index} value={option.value?? option.id}>
            {option.label || option.name || option.value}
          </option>
        ))}
      </select>

      {/* Helper Text */}
      {(helperText || error) && <HelperError id={id} error={error} helperText={helperText}/>}
    </div>
  );
}

// Default Props
CustomSelectBox.defaultProps = {
  label: "",
  error: "",
  id: "custom-select",
  onChange: () => {},
  value: [],
  options: [],
  fullWidth: false,
  labelColor: "",
  helperText: "",
  isMulti: false, // Add the default for isMulti
  placeholder: "Select an option...",
};

// Prop Types
CustomSelectBox.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]), // Allow string or array for value
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  fullWidth: PropTypes.bool,
  labelColor: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  isMulti: PropTypes.bool, 
  placeholder: PropTypes.string,
};

export default CustomSelectBox;
